import { t } from '@/i18n';

import type { RealEstateCommunityCategory } from '../types';
import { defineServerEnum, unknownLabel } from '@/shared/lib/utils/server-enum';

/**
 * TRAD-2599(배치4) — list-page/detail-page가 각자 같은 카테고리 라벨·색상을 하드코딩/중복
 * 정의하고 있었다(UI 일관성 룰 1 위반 — 같은 개념은 한 곳에서 관리해야 갈리지 않는다).
 * detail-page가 이미 `real_estate_community.category.trade/subscription/general` 카탈로그
 * 키로 구현해 뒀던 것을 정본으로 승격해 두 화면이 공유한다.
 */
// TRAD-3690 — ~~default: return category~~(서버가 더한 카테고리 코드가 그대로 화면에) → «알 수 없음». 색은 아래 default 가 이미 중립.
const COMMUNITY_CATEGORY = defineServerEnum(['TRADE', 'SUBSCRIPTION', 'GENERAL'] as const);

export const categoryLabel = (category: RealEstateCommunityCategory): string =>
  COMMUNITY_CATEGORY.match(category, {
    TRADE: t('real_estate_community.category.trade'),
    SUBSCRIPTION: t('real_estate_community.category.subscription'),
    GENERAL: t('real_estate_community.category.general'),
    UNKNOWN: unknownLabel(),
  });

/** 카테고리 배지 색상 — list-page(스위치문)와 detail-page(인라인 삼항)에 동일 값이 중복돼 있었다. */
export const categoryColor = (category: RealEstateCommunityCategory): string => {
  switch (category) {
    case 'TRADE': return 'bg-blue-500/15 text-blue-600 dark:text-blue-400';
    case 'SUBSCRIPTION': return 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400';
    case 'GENERAL': return 'bg-zinc-500/15 text-zinc-500';
    default: return 'bg-secondary text-muted-foreground';
  }
};
